// extracted by mini-css-extract-plugin
module.exports = {"container":"ready-to-learn-more-module--container--1qvYL","title":"ready-to-learn-more-module--title--3g8Z8","links":"ready-to-learn-more-module--links--3To4E"};